export default "__VITE_ASSET__Qmu4BOd___"